import { Button } from '@material-ui/core';
import { useCallback, useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { TransmissionFormType } from '.';
import en from '../../../lang/en-us';
import { SubmitButton } from '../../../lib/Button';
import { OtpField, ResendOtp, useTimer } from '../../../lib/OtpField';
import { verifyOtp } from '../../../redux-store/actions/login';
import { sendPhoneOTP } from '../../../redux-store/actions/nct';
import { PRE_LOGIN_TRANSMISSION } from '../../../redux-store/types/links';
import { OTP_RESPONSE, VerifyOtpPayload } from '../../../redux-store/types/login';
import { SEND_PHONE_OTP_PAYLOAD } from '../../../redux-store/types/nct';
import { OTP_ACTIONS } from '../../../utils/constants';
import { maskMobileNumber } from '../../../utils/utilityFunctions';
import { ActionHeader } from '../../dashboard/makeNct';
const { dashboard } = en;

export interface StateProps extends TransmissionFormType {
    role: string;
    reqId: string;
}
interface TransmissionOTPProps extends RouteComponentProps<any, any, StateProps> {
    sendPhoneOTP: (body: SEND_PHONE_OTP_PAYLOAD) => Promise<any>;
    verifyOtp: (body: VerifyOtpPayload) => Promise<any>;
    reqId?: string;
}

function TransmissionRequestOtpMobile(props: TransmissionOTPProps) {
    const [otpInput, setOtpInput] = useState<string[]>(new Array(6).fill(''));
    const otpRefInfo = useRef<OTP_RESPONSE | null>(null);
    const { startTimer, resetTimer, timer, stopTimer } = useTimer({});
    const { mobile, pan } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state || !pan) {
            return props.history.replace('/');
        }
        sendOtp();
    }, []);

    const sendOtp = useCallback(() => {
        async function callApi() {
            try {
                let { body = {} } = await props.sendPhoneOTP({
                    pan: '',
                    mobile: `+91${mobile}`,
                    pekrn: '',
                    // action: OTP_ACTIONS.PRELOGIN_UPDATE_PAN,
                    action: 'PRELOGIN_TRANSMISSION',
                });
                otpRefInfo.current = body;
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
    }, [mobile]);

    const onVerifyOtp = async () => {
        stopTimer();
        let payload: VerifyOtpPayload = {
            enteredOtp: otpInput.join(''),
            otpRef: otpRefInfo.current?.otpRef || '',
            // mobile,
            reqId: otpRefInfo.current?.reqId || '',
            action: PRE_LOGIN_TRANSMISSION,
        };
        try {
            await props.verifyOtp(payload);
            props.history.replace('/links/transmission-request-otp-email', {
                ...props.location.state,
                reqId: otpRefInfo.current?.reqId || '',
            });
        } catch (err: any) {
            alert(err.message);
            setOtpInput(new Array(6).fill(''));
        }
    };

    const onResend = () => {
        sendOtp();
        resetTimer();
    };
    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.TransmissionRequest.TransmissionUnitHeading} />
            {/* <h2 className="heading">
                <a onClick={() => props.history.goBack()} tabIndex={0}>
                    <img src="/images/left-arrow-black.svg" alt="Back" />
                </a>
            </h2> */}
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-otp-img.png" alt="" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.TransmissionRequest.otp.heading}
                            <span>{dashboard.TransmissionRequest.otp.mobile.headingSpan}</span>
                        </h3>
                        <p>
                            {dashboard.OtpScreen.otpPhoneSubject}{' '}
                            <span>{maskMobileNumber(mobile)}</span>
                        </p>
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setOtpInput(otp);
                            }}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButton
                            onClick={onVerifyOtp}
                            label={dashboard.OtpScreen.buttonText}
                            className="customBtn"
                            disabled={otpInput.join('').length !== 6}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(null, { sendPhoneOTP, verifyOtp })(TransmissionRequestOtpMobile);
